module.exports = __webpack_public_path__ + "img/banner2.833e801a.png";